import { ILimitSuccessResponseItem } from '@bg-shared/business/BettingLimits';
import { IFormattedBettingOption } from '@bg-shared/interfaces';

export const getMinMaxLimits = (
    options: IFormattedBettingOption[],
    limits?: Record<number, ILimitSuccessResponseItem>,
) =>
    options.reduce<ILimitSuccessResponseItem>(
        (finalValue, option) => {
            const optionLimits = limits?.[option.id];

            if (!optionLimits) {
                return finalValue;
            }

            // pick min from all min limits
            finalValue.min = Math.min(finalValue.min || Infinity, optionLimits.min);
            // pick max from all max limits
            finalValue.max = Math.max(finalValue.max, optionLimits.max);

            return finalValue;
        },
        { min: 0, max: 0 } as ILimitSuccessResponseItem,
    );
